module.exports = "pegasus/assets/themelp1/large/61.png";